import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { EventCategory, EventCategoryPayload } from "@project/types/event";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/event-categories`;
const SILENT: RequestConfig = { showNotification: false };

class EventCategoryService {
  listPage = (query: ListQuery = {}): Promise<PaginatedResult<EventCategory>> =>
    fetchListPage<EventCategory>(`${BASE}/`, query);

  get = async (id: number): Promise<EventCategory | undefined> => {
    const data = await get<ApiItemResponse<EventCategory> | EventCategory>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (payload: EventCategoryPayload): Promise<EventCategory> => {
    const data = await post<
      ApiItemResponse<EventCategory> | EventCategory,
      EventCategoryPayload
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(data);
    if (!item) {
      throw new Error("Failed to create event category.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<EventCategoryPayload>
  ): Promise<EventCategory | undefined> => {
    const data = await patch<
      ApiItemResponse<EventCategory> | EventCategory,
      Partial<EventCategoryPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const eventCategoryService = new EventCategoryService();
